import { httpCommon } from "./interceptor";

class LoginService {
  userLogin_Otp(inputdata: { email: string; password: string; device_fingerprint?: string }) {
    return httpCommon.post("users/login_otp/", inputdata);
  }

  getLoginOTPVerifyAPI(inputdata: {
    email: string;
    password: string;
    otp: string;
    device_fingerprint?: string;
  }) {
    return httpCommon.post("users/login_verify/", inputdata);
  }
}

const loginService = new LoginService();
export default loginService;
